var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-area padded vertically-centered red-screen"},[_c('h2',[_vm._v("Las cosas no están funcionando entre los dos "),_c('br'),_vm._v("¯\\_(ツ)_/¯")]),_c('p',[_vm._v("Por favor usa tu dispositivo en orientación vertical. Si estás en un computador, mejor usa tu celular :) ")])])
}]

export { render, staticRenderFns }